import { FC, HTMLAttributes } from 'react';

import { ConfigProvider, Tag, theme } from 'antd';
import cn from 'classnames';

import { EFilters } from 'features/Filters';
import { TLabelValue } from 'shared/typings';

import styles from './CheckableTag.module.scss';

interface IInfoTooltipProps extends HTMLAttributes<HTMLDivElement> {
	tag: TLabelValue;
	checked: boolean;
	onTagsChange: (filter: EFilters, value: string) => void;
}
const { useToken } = theme;

export const CheckableTag: FC<IInfoTooltipProps> = ({ className, checked, tag, onTagsChange }) => {
	const {
		token: { colorPrimary },
	} = useToken();

	return (
		<ConfigProvider
			theme={{
				token: {
					colorTextLightSolid: colorPrimary,
				},
			}}>
			<Tag.CheckableTag
				className={cn(styles.tag, className)}
				checked={checked}
				onChange={() => onTagsChange(EFilters.STATUS, tag.value)}>
				{tag.label}
			</Tag.CheckableTag>
		</ConfigProvider>
	);
};
